export default {
  REMOVE_ITEM: 'remove_item',
  OUT_OF_STOCK_ITEM: 'out_of_stock_item',
  REMOVE_TRADE_IN_ITEM: 'remove_trade_in_item',
};
